import { render } from "./Sake.vue?vue&type=template&id=ac594282"
const script = {}
script.render = render

export default script